export class Message {
    public MessageId: number;
    public TicketId: number;
    public Title: string;
    public Text: string;
    public Level: number;
}


// WEBPACK FOOTER //
// ./src/entities/message.ts